<template>
  <div class="firstPage_bg" :style="{backgroundImage: 'url(https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/202108171526.gif) ',height: screenHeight }" style="position: relative;">
  <!-- <div class="firstPage_bg" style="position: relative;height:100%">   -->
    <!-- <video id="home-video" ref="videoH" src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/mp4/head.mp4" autoplay="true" muted="" loop="" style="width: 100%;z-index:-1;position: absolute;"></video> -->
    <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/black-circle.png" class="first-page-circle">
    <div class="downloadButton" @click="this.$goToUserClient">
      <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/download-icon.png"><span>客户端下载</span>
    </div>
    <!-- 红包效果 -->
    <!-- <div class="tri-up i-b-img" style="width:70px;">
      <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/hb.png" style="width:100%;" class="leftToRight">
      <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/hb_title.png" style="width:100%;" class="smallToBig">
    </div> -->
    <div class="width100 text-center">
      <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/down_arrow.png" class="downButton" @click="moveSectionDown">
    </div>
  </div>
</template>

<script>
export default {
  name: 'firstPage',
  data(){
    return {
      screenHeight:0
    }
  },
  props: {
    activeShow: Number
  },
  mounted(){
  },
  created(){
    this.screenHeight = document.documentElement.clientHeight+'px';
  },
  methods:{
    play(){
      this.$refs.videoH.play()
    },
    // 翻页方法 子传父
    moveSectionDown(){
      this.$emit('moveSectionDown');
    }
  }
}
</script>

<style>
.fp-completely{
  /* background-color: transparent !important; */
}
  .i-b-img {
    text-align: center;
    color: #fff;
    position: relative;
    -webkit-transform-origin: center center;
    -ms-transform-origin: center center;
    transform-origin: center center;
  }
  .leftToRight{
    -webkit-animation: myfirst .6s infinite;
    animation: myfirst .6s infinite;
  }
  .tri-up {
    position: absolute;
    width: 35px;
    height: 15px;
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
    right: 25px;
    bottom: 180px;
  }
  .smallToBig{
    position:relative;
    animation:mymove 3s infinite;
    -webkit-animation:mymove 3s infinite; /*Safari and Chrome*/
    animation-direction:alternate;/*轮流反向播放动画。*/
    animation-timing-function: ease-in-out; /*动画的速度曲线*/
    -webkit-animation:mymove 3s infinite;
    -webkit-animation-direction:alternate;/*轮流反向播放动画。*/
    -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/
  }
  @keyframes mymove
  {
    0%{
      transform: scale(1);  /*开始为原始大小*/
    }
    25%{
      transform: scale(1.1); /*放大1.1倍*/
    }
    50%{
      transform: scale(1);
    }
    75%{
      transform: scale(1.1);
    }

  }
  @keyframes myfirst {
    0% {
      -webkit-transform: rotate(-4deg);
      transform: rotate(-4deg);
      -webkit-transform-origin: center center;
      transform-origin: center center;
    }
    50% {
      -webkit-transform: rotate(4deg);
      transform: rotate(4deg);
      -webkit-transform-origin: center center;
      transform-origin: center center;
    }
    100% {
      -webkit-transform: rotate(-4deg);
      transform: rotate(-4deg);
      -webkit-transform-origin: center center;
      transform-origin: center center;
    }
  }
</style>
